import { getCycle } from "./getCycle";

/** The Linear cycle running today, by its title number. */
export const getCurrentCycle = () => getCycle(new Date());
